import { render, staticRenderFns } from "./dataSheet.vue?vue&type=template&id=2c6d6049&scoped=true&"
import script from "./dataSheet.vue?vue&type=script&lang=js&"
export * from "./dataSheet.vue?vue&type=script&lang=js&"
import style0 from "./dataSheet.vue?vue&type=style&index=0&id=2c6d6049&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6d6049",
  null
  
)

export default component.exports